// The header shrinks as it sticks, part way through the scroll, so it ends up
// covering less of the page than it does at rest. Desktop only — the mobile
// header keeps its height.
export const HEADER_SHRINK = 39;

const DESKTOP = "(min-width: 1024px)";

export default function headerShrink() {
  return window.matchMedia(DESKTOP).matches ? HEADER_SHRINK : 0;
}
